import * as React from 'react';
export const CLSvg = React.forwardRef(function CLSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M8 2v6h8V3.998A1.993 1.993 0 0 0 14.002 2H8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M16 8h-1V4c-.09-.598-.517-1.002-1-1H8V2h6c1.059 0 1.948.894 2 2-.052-.295.065 4.245 0 4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M0 8v4.002C0 13.106.895 14 1.994 14h12.012A1.998 1.998 0 0 0 16 12.002V8H0Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#43458B',
        d: 'M1.998 2A2 2 0 0 0 0 3.998V8h8V2H1.998Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'm3.98 6.157-1.334.377.464-1.307L2 4.38l1.393-.19L3.98 3l.587 1.19 1.393.19-1.11.847.464 1.307z',
      }),
    ),
  );
});
CLSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var CL = {
  category: 'flag',
  colorable: false,
  name: 'CL',
  svg: CLSvg,
};
